import React,{useState} from 'react'
import {BiChevronDown} from 'react-icons/bi'
import {AiOutlineSearch} from 'react-icons/ai'
import {MdAddBox} from 'react-icons/md'
import CustomerSelectorItem from '../CustomerSelectorItem';
import { useCurrent } from '../../hooks';
import TagListItem from './TagListItem';

const MwSelectorMulti = ({label,_data,dataType,onClickNew,setSelectedItem,selectedItem,initalValue='Choose',withLabel=true,withAddNew=true,className}) => {
    const [inputValue,setInputValue] = useState('');
    const {currentLangId} = useCurrent()
    const [open,setOpen] = useState(false);

    const onSelectedHandler = (item) => {
        if (selectedItem.some(obj => obj.value === item.value)) return ;
        setSelectedItem([...selectedItem,{...item,label:item.label}])
        setOpen(false);
        setInputValue("")
    }
    const dataList = _data &&  _data?.map((item) => {
        if(dataType === 'customer' || dataType === 'salesman'){
            return <CustomerSelectorItem 
                        key={item._id}
                        item={item} 
                        setSelectedItem={setSelectedItem} 
                        setOpen={setOpen}
                        setInputValue={setInputValue}
                        inputValue={inputValue}
                        />
        }
        if(dataType === 'labelValue' ){
            if(item.lang === currentLangId )
                return <div 
                            className={`cursor-default border-t border-slate-100 px-4 py-2 transition-colors hover:bg-[#251658]/5 hover:text-[#251658] ${item?.label?.toLowerCase().startsWith(inputValue) ? 'block' : 'hidden'}`}
                            key={item.value}
                            onClick={()=>onSelectedHandler(item)}
                            >
                            {item.label}
                        </div>
        }
        return null;
    })

    const removeItem = (tag) => {
        const tagFilter =  selectedItem.filter(t => t.label !== tag); 
        setSelectedItem(tagFilter)
    }

    return (
        <>
            <div className={`  ${className}`}>
                <label className='mb-1 block px-1 text-xs font-medium text-[#251658]'> {label} </label>
                <div
                    onClick={()=>setOpen(!open)}
                    className='flex h-11 w-full cursor-default items-center justify-between rounded-xl border border-slate-200 bg-white px-3 text-xs text-slate-700 transition-all duration-200 hover:border-slate-300' >
                        <div className='flex flex-1 flex-wrap gap-1' >
                            {selectedItem?.length > 0 ? selectedItem?.map((el,indx)=>(<TagListItem key={`${el.value}-${indx}`} tag={el.label} removeTagHandler={()=>removeItem(el.label)} />))  : <span className='text-slate-500'>{initalValue}</span>}
                        </div>
                        <BiChevronDown size={20} className='text-slate-500'/>
                </div>
                <ul className={`absolute start-0 z-50 mt-2 w-full overflow-y-auto rounded-2xl border border-slate-200 bg-white shadow-xl ${open ? 'block max-h-60' : 'hidden max-h-0'}`}>
                    <div className='sticky top-0 border-b border-slate-100 bg-white p-3'>
                        { 
                        withAddNew && <div className='text-end'>
                            <div className='absolute top-4 end-4 text-[#251658]'  
                            onClick={()=>{ 
                                onClickNew()
                                setOpen(false) 
                            }}
                            > <MdAddBox size={24}/> </div>
                        </div>
                        }
                        <div className='flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-3'>
                            <AiOutlineSearch size={18} className='text-slate-500 ' />
                            <input 
                                type="text"
                                placeholder= {label}
                                className='w-full bg-transparent p-2 text-xs text-slate-700 outline-none placeholder:text-slate-400'
                                value={inputValue}
                                onChange={(e)=>setInputValue(e.target.value.toLowerCase())}
                                />
                        </div>
                    </div>
                    <div className='mb-3 text-slate-600 '>
                        {dataList}
                    </div>
                </ul>
            </div>
        </>
    )
}

export default MwSelectorMulti
